import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[balloonTooltip]'
})
export class BalloonTooltipDirective {

  @Input('balloonTooltip') text: string;
  private tooltip: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.text || this.tooltip) {
      return;
    }

    this.tooltip = this.renderer.createElement('span');
    this.renderer.addClass(this.tooltip, 'balloon-tooltip');
    this.renderer.appendChild(this.tooltip, this.renderer.createText(this.text));

    // разместим относительно экрана
    this.renderer.appendChild(document.body, this.tooltip);

    const rect = this.el.nativeElement.getBoundingClientRect();
    this.tooltip.style.position = 'absolute';
    this.tooltip.style.top = rect.top - 40 + 'px';
    this.tooltip.style.left = rect.left + 'px';
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltip) {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }
  }
}
